/**
 * Repère, dans un texte libre, les données qui désignent une personne ou son
 * argent — adresse e-mail, téléphone français, IBAN, BIC, numéro de sécurité
 * sociale — et les remplace par des `*`, caractère pour caractère (les espaces
 * restent, la mise en page du texte ne bouge pas).
 *
 * Partagé : le replay du navigateur (src/utils/posthog-masquage.js) masque
 * ainsi le texte affiché, et le serveur le message d'une erreur avant de le
 * remonter (server/services/remontee-erreurs.service.js).
 */

const EMAIL = /[^\s@<>"'(),;:]+@[^\s@<>"'(),;:]+\.[A-Za-z]{2,}/g;

// FR76 3000 6000 0112 3456 7890 189, groupé ou non.
const IBAN = /\b[A-Z]{2}\d{2}(?: ?[A-Z0-9]{4}){2,7}(?: ?[A-Z0-9]{1,3})?\b/g;

// BNPAFRPP, AGRIFRPP882… Pays restreints à ceux qu'on croise ici : un mot de huit
// capitales quelconque (« DOSSIERS ») passerait sinon pour un BIC.
const BIC = /\b[A-Z]{4}(?:FR|MC|BE|LU|DE|CH)[A-Z0-9]{2}(?:[A-Z0-9]{3})?\b/g;

// 1 85 05 78 006 084 36 : sexe, année, mois, département (2A/2B en Corse),
// commune, ordre, clé facultative ; groupé ou non.
const NIR = /\b[12378] ?\d{2} ?\d{2} ?(?:\d{2}|2[AB]) ?\d{3} ?\d{3}(?: ?\d{2})?\b/g;

// 06 12 34 56 78, 06.12.34.56.78, 0612345678, +33 6 12 34 56 78, 0033 (0)6…
const TELEPHONE = /(?:(?:\+|\b00)33[\s.-]?(?:\(0\)[\s.-]?)?|\b0)[1-9](?:[\s.-]?\d{2}){4}\b/g;

const MOTIFS = [EMAIL, IBAN, BIC, NIR, TELEPHONE];

// Un texte sans @, sans chiffre et sans quatre capitales d'affilée ne peut rien
// contenir de tout ça : la plupart des textes d'une page sortent ici.
const INDICE = /[@\d]|[A-Z]{4}/;

function etoiles(trouve) {
  return trouve.replace(/\S/g, '*');
}

/**
 * @param {string} texte
 * @returns {string} le texte, ses données sensibles remplacées par des `*`
 */
export function masquerDonneesSensibles(texte) {
  if (typeof texte !== 'string' || !texte || !INDICE.test(texte)) return texte;
  let resultat = texte;
  for (const motif of MOTIFS) {
    resultat = resultat.replace(motif, etoiles);
  }
  return resultat;
}
